import { render } from "./ViewResetPassword.vue?vue&type=template&id=aade4fda&ts=true"
import script from "./ViewResetPassword.vue?vue&type=script&lang=ts"
export * from "./ViewResetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__